module.exports = __webpack_public_path__ + "static/Gilroy-Regular-48deca2f4c65390ae3f01037cefba315.woff2";